'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var url = exports.url = function url(_url) {
  return _url.replace('//', '/');
};

var slugify = exports.slugify = function slugify(text) {
  if (!text) {
    return text;
  }

  return text.toString().toLowerCase().replace(/\s+/g, '-') // Replace spaces with -
  .replace(/[^\w-]+/g, '') // Remove all non-word chars
  .replace(/--+/g, '-') // Replace multiple - with single -
  .replace(/^-+/, '') // Trim - from start of text
  .replace(/-+$/, ''); // Trim - from end of text
};

var objToQueryString = exports.objToQueryString = function objToQueryString(obj) {
  var omitConvertableToFalse = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  var params = JSON.parse(JSON.stringify(obj));

  if (omitConvertableToFalse) {
    Object.keys(params).forEach(function (key) {
      return (params[key] == null || params[key] == false) && delete params[key];
    });
  }

  return Object.entries(params).map(function (i) {
    return [i[0], encodeURIComponent(i[1])].join('=');
  }).join('&');
};